import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AddNode, ClearFilter, DeleteIcon, Edit, EditButtonIcon, FilterIcon, InfoIcon1, RemoveIcon, SaveFilter } from '../../../assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table'
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, Tooltip, Box, CircularProgress } from '@mui/material'
import { useHistory } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component'
import AlertTemplateMessage from '../../Configuration/AlertTemplate/AlertTemplateMessage'
import DeviceAdditionForm from './DeviceAdditionForm'
import Swal from 'sweetalert2'
import filtersConfig from '../Filters'
import { deleteDeviceService, getAllFilters, getAllDeviceList, getInterfaceById, getAllZoneList, updateBulkDeviceDetails } from '../../../services/configurationServices'
import { MULTI_TIME_ZONE } from '../../../config'
import CCTVDeviceForm from './Forms/CCTVDeviceForm'
import ACSDeviceForm from './Forms/ACSDeviceForm'
import RTUDeviceForm from './Forms/RTUDeviceForm'
import FASDeviceForm from './Forms/FASDeviceForm'
import IDSDeviceForm from './Forms/IDSDeviceForm'
import { SuccessToast } from '../../../CustomHooks/SuccessToast'
import { ErrorToast } from '../../../CustomHooks/ErrorToast'
import CCTVEditForm from './Edits/CCTVEditForm'

import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


const DeviceConfig = ({showSuccessToast}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const wrapperRef = useRef(null);
  const [showAddSite, setShowAddSite] = useState(false);
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const [showSavedFilterDeleteModal, setShowSavedFilterDeleteModal] = useState(false)
  const [openInfoFilter, setOpenInfoFilter] = useState(false)
  const [modalFilterName, setModalFilterName] = useState("")
  const [selected, setSelected] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [filterData, setFilterData] = useState(null);
  const [deviceData, setDeviceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedDeviceType, setSelectedDeviceType] = useState('');
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({
    ZoneID: ''
  });
  const [interfaceData, setInterfaceData] = useState(null);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [bulkEditDeviceType, setBulkEditDeviceType] = useState('');
  const [bulkEditLoading, setBulkEditLoading] = useState(false);
  const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);

  const [visiblePasswords, setVisiblePasswords] = useState({});


  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [globalFilter, setGlobalFilter] = useState('');

  // Enhanced configuration with extensible field mappings
  const getPageConfiguration = () => {
    const pageConfig = filtersConfig.find(config => config.pagename === 'DeviceConfiguration');
    if (!pageConfig) {
      console.warn('DeviceConfiguration not found in filters config');
      return { filters: {}, fieldMapping: {}, displayConfig: {} };
    }
    return pageConfig;
  };

  const pageConfig = getPageConfiguration();
  const pageFilters = pageConfig.filters;
  
  // Dynamic field mapping configuration - can be moved to external config
  const defaultFieldMapping = {
    'Customer': 'ClientName',     // Display field for Customer dropdown
    'State': 'statename', 
    'City': 'City',
    'Site': 'SiteName',           // Display field for Site dropdown
    'Zone': 'ZoneName',
    'Interface': 'InterfaceName',
    'Device': 'DeviceName'
  };

  // Field mapping for API parameter values (ID fields)
  const apiFieldMapping = {
    'Customer': 'ClientId',       // API parameter field for Customer
    'State': 'statemasterid', 
    'City': 'City',
    'Site': 'SiteID',             // API parameter field for Site
    'Zone': 'ZoneID',
    'Interface': 'InterfaceId',
    'Device': 'DeviceID'
  };

  // Use configured field mapping or fall back to default
  const fieldMapping = pageConfig.fieldMapping || defaultFieldMapping;

  // Get the actual field name from configuration (with fallback to default mapping)
  const getFieldName = (filterKey) => {
    const filterConfig = pageFilters[filterKey];
    if (filterConfig && filterConfig.fieldName) {
      return filterConfig.fieldName;
    }
    return fieldMapping[filterKey] || filterKey;
  };

  // Get placeholder text from configuration
  const getPlaceholderText = (filterKey, filterConfig) => {
    if (filterConfig.placeholder) {
      return filterConfig.placeholder;
    }
    return `Select ${filterConfig.label}${filterConfig.mandatory ? '*' : ''}`;
  };
  
  // Excel-like Filter Utility - filters options based on other active selections
  const getFilteredOptions = (filterKey, valueKey, labelKey) => {
    if (!filterData || !filterData.Data) {
        return [];
    }

    // Build a filter object with only selected values for each filter (excluding current filter)
    const activeSelections = {};
    Object.keys(pageFilters).forEach(key => {
        const selected = filterValues[key];
        if (
            key !== filterKey &&
            Array.isArray(selected) &&
            selected.length > 0
        ) {
            activeSelections[key] = selected.map(item => 
                typeof item === "object" ? item.value : item
            );
        }
    });

    // Filter data based on all other active selections
    const filtered = filterData.Data.filter(item => {
        return Object.entries(activeSelections).every(([key, selectedVals]) => {
            const apiFieldName = apiFieldMapping[key] || defaultFieldMapping[key] || key;
            return selectedVals.includes(item[apiFieldName]);
        });
    });

    // Get unique options for this filter
    const seen = new Set();
    return filtered
        .filter(item => {
            const val = item[valueKey];
            if (!val || seen.has(val)) return false;
            seen.add(val);
            return true;
        })
        .map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }))
        .sort((a, b) => {
            // Sort options in ascending order by label
            return a.label.localeCompare(b.label, undefined, { 
                numeric: true, 
                sensitivity: 'base' 
            });
        });
  };

  // Create options from API filterData with Excel-like filtering - now fully dynamic
  const getFilterOptions = (filterKey) => {
    if (!filterData || !filterData.Data) {
        return [];
    }
    
    const displayFieldName = getFieldName(filterKey);           // Field for label (e.g., ClientName)
    const valueFieldName = apiFieldMapping[filterKey] || displayFieldName;  // Field for value (e.g., ClientId)
    
    return getFilteredOptions(filterKey, valueFieldName, displayFieldName);
  };

  const handleFilterChange = (filterKey, value) => {
    if(filterKey == 'Customer' && value.length > 0) {
      setSelectedCustomer(value[0])
    }
    setFilterValues(prev => {
        const newValues = {
            ...prev,
            [filterKey]: value
        };

        // Smart dependency clearing - clear dependent filters when parent changes
        const filterConfig = pageFilters[filterKey];
        if (filterConfig) {
            // Find and clear all dependent filters
            Object.entries(pageFilters).forEach(([key, config]) => {
                if (config.parentFilter === filterKey) {
                    newValues[key] = [];
                    // Recursively clear dependencies
                    const clearDependencies = (parentKey) => {
                        Object.entries(pageFilters).forEach(([depKey, depConfig]) => {
                            if (depConfig.parentFilter === parentKey) {
                                newValues[depKey] = [];
                                clearDependencies(depKey);
                            }
                        });
                    };
                    clearDependencies(key);
                }
            });
        }

        return newValues;
    });

    // Only reset table state when mandatory filters are changed
    const filterConfig = pageFilters[filterKey];
    if (filterConfig && filterConfig.mandatory) {
        // Reset table state when mandatory filters change
        setDeviceData([]);
        setFiltersApplied(false);
        setRowSelection({});
        setVisiblePasswords({});
        setPagination({
            pageIndex: 0,
            pageSize: 10,
        });
    }
  };

  // Enhanced validation with better error messaging
  const isMandatoryFiltersMissing = () => {
    return Object.entries(pageFilters).some(([filterKey, filterConfig]) => {
        return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
    });
  };

  // Get missing mandatory filters for better user feedback
  const getMissingMandatoryFilters = () => {
    return Object.entries(pageFilters)
        .filter(([filterKey, filterConfig]) => {
            return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
        })
        .map(([filterKey, filterConfig]) => filterConfig.label);
  };

  // Enhanced filter button tooltip
  const getFilterButtonTooltip = () => {
    const missingFilters = getMissingMandatoryFilters();
    if (missingFilters.length > 0) {
        return `Please select: ${missingFilters.join(', ')}`;
    }
    return "Apply Filter";
  };

  // Clear all filters function
  const handleClearAllFilters = () => {
    setFilterValues({});
    setDeviceData([]);
    setFiltersApplied(false);
    setRowSelection({});
    // Reset password visibility state when clearing filters
    setVisiblePasswords({});
    setGlobalFilter('');
    setPagination({
        pageIndex: 0,
        pageSize: 10,
    });
  };

  // Handle global filter change with pagination reset
  const handleGlobalFilterChange = (value) => {
    setGlobalFilter(value);
    // Reset to first page whenever search changes
    setPagination(prev => ({
      ...prev,
      pageIndex: 0
    }));
  };

  // Apply filters function with API integration
  const handleApplyFilters = async () => {
    if (!isMandatoryFiltersMissing()) {
        setLoading(true);
        setFiltersApplied(true); // Set filters as applied at the start, like SiteConfig
        
        try {
            // Map filter values to API parameters
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const apiParams = {
                UserID: user.UserID || '',
                ClientID: '',
                SiteID: ''
            };

            // Map Customer filter to ClientID
            if (filterValues.Customer && filterValues.Customer.length > 0) {
                apiParams.ClientID = filterValues.Customer.map(item => 
                    typeof item === 'object' ? item.value : item
                ).join(',');
            }

            // Map Site filter to SiteID  
            if (filterValues.Site && filterValues.Site.length > 0) {
                apiParams.SiteID = filterValues.Site.map(item => 
                    typeof item === 'object' ? item.value : item
                ).join(',');
            }
            if (filterValues.Interface && filterValues.Interface.length > 0) {
                apiParams.InterfaceId = filterValues.Interface.map(item => 
                    typeof item === 'object' ? item.value : item
                ).join(',');
            }
            if (filterValues.State && filterValues.State.length > 0) {
                apiParams.statemasterid = filterValues.State.map(item => 
                    typeof item === 'object' ? item.value : item
                ).join(',');
            }
            if (filterValues.City && filterValues.City.length > 0) {
                apiParams.City = filterValues.City.map(item =>
                    typeof item === 'object' ? item.value : item
                ).join(',');
            }

      
            const response = await getAllDeviceList(apiParams);
            
            if (response && response.Data) {
                setDeviceData(response.Data);
                // Reset password visibility state when new data is loaded
                setVisiblePasswords({});
            } else {
                setDeviceData([]);
                setVisiblePasswords({});
                console.warn('No device data received');
            }
        } catch (error) {
            console.error('Error loading device data:', error);
            setDeviceData([]);
        } finally {
            setLoading(false);
        }
    }
  };

  const getStatus = (value) => {
    if(value === undefined || value === null) {
      return 'Not Applicable';
    }
    if (value === true || value === 'true') {
      return 'Enabled';
    }
    if (value === false || value === 'false') {
      return 'Disabled';
    }
    return value;
  };

  const getCamStatus = (value) => {
    if(value === undefined || value === null) {
      return 'Not Applicable';
    }
    return value;
  }

  const BinaryStatusCell = (value) => {
    if(value === undefined || value === null) {
      return 'Not Applicable';
    }
    if (value === '1'|| value === 1) {
      return 'Enabled';
    }
    if (value === '0' || value === 0) {
      return 'Disabled';
    }
    return value;
  };

  // Toggle password visibility for a specific row
  const togglePasswordVisibility = (DeviceId) => {
    setVisiblePasswords(prev => ({
      ...prev,
      [DeviceId]: !prev[DeviceId]
    }));
  };

    // Password cell component
  const PasswordCell = ({ row }) => {
    const DeviceId = row.original.DeviceId || row.original.DeviceId;
    const password = row.original.CamPassword;
    const isVisible = visiblePasswords[DeviceId] || false;

    const handleToggle = (e) => {
      e.stopPropagation();
      togglePasswordVisibility(DeviceId);
    };


    // Handle null/undefined values
    if (password === null || password === undefined) {
      return (
        <span style={{ 
          // color: '#9e9e9e',
          // fontStyle: 'italic'
        }}>
          Not Applicable
        </span>
      );
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontFamily: 'monospace', minWidth: '80px' }}>
          {isVisible ? password : '•'.repeat(Math.max(password.length, 8))}
        </span>
        <IconButton
          size="small"
          onClick={handleToggle}
          sx={{ padding: '2px' }}
          title={isVisible ? 'Hide password' : 'Show password'}
        >
          {isVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
        </IconButton>
      </div>
    );
  };

  const columns = useMemo(() => {
    // Dynamic columns based on API response
    const dynamicColumns = [];
    
    if (deviceData.length > 0) {
      const sampleData = deviceData[0];
      
      // Define column mappings for better display names and formatting
      const columnMappings = {
        'DeviceName': { header: 'Device Name', size: 250 },
        'ClientName': { header: 'Customer Name', size: 250 },
        'SiteName': { header: 'Site Name', size: 250 },
        'ZoneName': { header: 'Zone Name', size: 250 },
        'InterfaceName': { header: 'Interface Name', size: 250 },
        'Interfacesubtypename': { header: 'Brand Name', size: 220, Cell: ({ row }) => getStatus(row.original.Interfacesubtypename) },
        //'cctvHooterEnabledFlag': { header: 'CCTV Hooter Enabled', size: 220, Cell: ({ row }) => getStatus(row.original.cctvHooterEnabledFlag) },
        'ExternalId': { header: 'Identifier Name', size: 250, Cell: ({ row }) => getStatus(row.original.ExternalId) },
        'CameraIp': { header: 'Camera IP', size: 220, Cell: ({ row }) => getStatus(row.original.CameraIp) },
        'Communicationport': { header: 'Communication Port', size: 280, Cell: ({ row }) => getStatus(row.original.Communicationport) },
        'InternetProtocolPort': { header: 'HTTP Port', size: 200, Cell: ({ row }) => getStatus(row.original.InternetProtocolPort) },
        'CamUser': { header: 'Username', size: 280, Cell: ({ row }) => getStatus(row.original.CamUser) },
        'CamPassword': { header: 'Password', size: 280, 
          Cell: ({ row }) => getStatus(row.original.CamPassword), 
          muiTableBodyCellProps: {
            className: 'PasswordCell',
          }, },
        'CameraPort': { header: 'Camera Port', size: 220, Cell: ({ row }) => getStatus(row.original.CameraPort) },
        'ChannelNo' : { header: 'Channel No', size: 220, Cell: ({ row }) => getStatus(row.original.ChannelNo) },
        'RTSPCameraUrl': { header: 'RTSP Camera URL', size: 450, Cell: ({ row }) => getStatus(row.original.RTSPCameraUrl) },
        'DeviceType': { header: 'Device Type', size: 220},
        'Abbreviation': { header: 'Timezone', size: 200 },
        // 'PlayBackChannelNum': { header: 'Playback Channel No', size: 280, Cell: ({ row }) => getStatus(row.original.PlayBackChannelNum) },
        'IsTranscodingEnabled': { header: 'Transcoding', size: 220, Cell: ({ row }) => getStatus(row.original.IsTranscodingEnabled) },
        'IsPlayBackTranscodingEnabled': { header: 'Playback Transcoding', size: 280, Cell: ({ row }) => getStatus(row.original.IsPlayBackTranscodingEnabled) },
        'isTwoWayEnabled': { header: 'Two Way Communication', size: 320, Cell: ({ row }) => getStatus(row.original.isTwoWayEnabled) },
        'PTZ': { header: 'PTZ', size: 150, Cell: ({ row }) => BinaryStatusCell(row.original.PTZ) },
        'ISPlaybackUTC': { header: 'Playback UTC', size: 220, Cell: ({ row }) => getStatus(row.original.ISPlaybackUTC) },
        'DeviceStage': { header: 'Device Stage', size: 240 },
        'Description': { header: 'Description', size: 350 },
        'alarmpanelHooterEnabledFlag': { header: 'Alarm panel Hooter', size: 270, Cell: ({ row }) => getStatus(row.original.alarmpanelHooterEnabledFlag) },
        'cctvHooterEnabledFlag': { header: 'CCTV Hooter', size: 250, Cell: ({ row }) => getStatus(row.original.cctvHooterEnabledFlag) },
        'CCTVMonitoring': { header: 'CCTV Monitoring', size: 250, Cell: ({ row }) => getStatus(row.original.CCTVMonitoring) },
        'AlertMonitoring': { header: 'Alert Monitoring', size: 250, Cell: ({ row }) => getStatus(row.original.AlertMonitoring) },
        'HMMonitoring': { header: 'HM Monitoring', size: 250, Cell: ({ row }) => getStatus(row.original.HMMonitoring) },
        'CCTVRecordingBackup': { header: 'CCTV Recording Backup', size: 300, Cell: ({ row }) => getStatus(row.original.CCTVRecordingBackup) },
        'SerialNo': { header: 'Serial Number', size: 280 },
        'IsOnvif': { header: 'Onboarded via Onvif', size: 220, Cell: ({ row }) => row.original.IsOnvif ? 'Yes' : 'No' },
        // 'Interfacesubtypename': { header: 'Brand Name', size: 220 },
        // 'CamUser': { header: 'Camera Username', size: 280, Cell: ({ row }) => getCamStatus(row.original.CamUser) },
        // 'CamPassword': { header: 'Camera Password', size: 280, muiTableBodyCellProps: {
        //     className: 'PasswordCell',
        //   }, },
      };

      // Skip certain fields that shouldn't be displayed as columns
      const skipFields = ['DeviceId', 'ParentDeviceID', 'DeviceTypeID', 'SiteId', 'InterfaceId', 'CreatedBy',
        'DeleteFlag', 'Metadata', 'Lat', 'Long', 'Altitude', 'TimeZoneID', 'OrganizationMasterID', 'UpdatedateTime', 'CreatedOn', 
        'ModifiedBy','ModifiedON', 'DeleteDateTime', 'DeviceStageId', 'EvidenceURL', 'ClientId', 'SiteID', 'ZoneID',
          'SubTypeLive', 'SubTypePlayback', 'PlayBackChannelNum'];

      // Create columns in the order defined by columnMappings
      Object.keys(columnMappings).forEach(key => {
        // Only add column if the field exists in the data and is not in skip list
        if (sampleData.hasOwnProperty(key) && !skipFields.includes(key)) {
          const mapping = columnMappings[key];
          const column = {
            accessorKey: key,
            header: mapping.header,
            size: mapping.size,
            filterVariant: 'text',
          };

          // Use Cell component from columnMappings if provided
          if (mapping.Cell) {
            column.Cell = mapping.Cell;
          }
          if (mapping.muiTableBodyCellProps) {
            column.muiTableBodyCellProps = mapping.muiTableBodyCellProps;
          }

          // Special handling for Password column
          if (key === 'CamPassword') {
            column.Cell = PasswordCell;
            column.enableSorting = false;
          }

          dynamicColumns.push(column);
        }
      });

      // Add any remaining fields from sampleData that aren't in columnMappings (fallback)
      Object.keys(sampleData).forEach(key => {
        if (skipFields.includes(key) || columnMappings[key]) return;

        const column = {
          accessorKey: key,
          header: key.replace(/([A-Z])/g, ' $1').trim(),
          size: 150,
          filterVariant: 'text',
        };

        dynamicColumns.push(column);
      });
    }

    // Always add actions column at the end
    dynamicColumns.push({
      accessorKey: "actions",
      header: "Actions",
      enableColumnActions: false,
      enableSorting: false,
      enableColumnOrdering: false,
      Cell: ({ row }) => (
        <div className="ActionBtns">
          <Tooltip title="Edit" placement="bottom">
            <button 
              className="DataAccessEdit borderButton" 
              onClick={() => showDeviceForm(row.original)}
              > {/*Disable edit button for ONVIF onboarded interfaces */}
              <EditNoteIcon className="ActionsIcon" />
            </button>
          </Tooltip>

          <Tooltip title="Delete" placement="bottom">
            <button className="DataAccessEdit borderButton" onClick={e => onDeleteChange(e, row.original)}>
              <DeleteForeverIcon className="ActionsIcon" />
            </button>
          </Tooltip>
        </div>
      ),
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          backgroundColor: "#064dc3",
          borderTopRightRadius: "20px",
          color: "white",
          fontWeight: "bold",
          zIndex: 3,
          textAlign: "center",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          zIndex: 2,
          textAlign: "center",
        },
      },
    });

    return dynamicColumns;
  }, [deviceData, visiblePasswords]);

  const pagedData = useMemo(() => {
    let filteredData = deviceData;
    
    // Apply global filter to complete dataset first
    if (globalFilter) {
      filteredData = deviceData.filter(item => 
        Object.values(item).some(value => 
          String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
        )
      );
    }
    
    // Then apply pagination to filtered data
    const start = pagination.pageIndex * pagination.pageSize;
    const end = start + pagination.pageSize;
    return filteredData.slice(start, end);
  }, [deviceData, pagination, globalFilter]);

  // Get filtered count for pagination
  const filteredCount = useMemo(() => {
    if (!globalFilter) return deviceData.length;
    
    return deviceData.filter(item => 
      Object.values(item).some(value => 
        String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
      )
    ).length;
  }, [deviceData, globalFilter]);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await getAllFilters({ Entity: 'Device' });
        setFilterData(response);
      } catch (error) {
        console.error('Error loading device filters:', error);
        setFilterData(null);
      }
    };
    
    fetchFilters();
  }, []);

  // Reset row selection when form is closed
  useEffect(() => {
    if (!showAddSite) {
      setRowSelection({});
      setSelectedRow(null);
      setFormData({});
      setSelectedDeviceType('');
      setFormErrors({});
      setInterfaceData(null); // Clear interface data when form is closed
      handleApplyFilters(); // Refresh device data when form is closed
    }
  }, [showAddSite]);

  useEffect(() => {
    if(showBulkEditModal){
      
    } else {
      // Reset bulk edit state when modal closes
      setBulkEditDeviceType('');
      setBulkEditLoading(false);
      setFormData({});
      setFormErrors({});
    }
  }, [showBulkEditModal]);

  const fetchFilters = async () => {
    try {
      const response = await getAllFilters({ Entity: 'Device' });
      setFilterData(response);
    } catch (error) {
      console.error('Error loading device filters:', error);
      setFilterData(null);
    }
  };

  const fetchZones = async () => {
    const siteId = filterValues?.Site?.[0]?.value || null;
    const customerId = filterValues?.Customer?.[0]?.value || null;

    if (siteId && customerId) {
      try {
        const response = await getAllZoneList({CustomerID: customerId, SiteID: siteId });
        if (response && response.Status === 'success' && response.Data) {
          const zoneOptions = response.Data.map((zone) => ({
            value: zone.ZoneID,
            label: zone.ZoneName,
          }));
          setZoneOptions(zoneOptions);
        } else {
          setZoneOptions([]);
        }
      } catch (error) {
        console.error('Error fetching zones:', error);
        setZoneOptions([]);
      }
    }
  };

  const handleZoneId = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const renderBulkEditForm = () => {
    switch (bulkEditDeviceType) {
      case 'ACS':
        return (
          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Zone*</label>
              <select
                className="inputType ArrowSelectClass"
                value={formData.ZoneID || ""}
                onChange={(e) => {
                  handleZoneId('ZoneID', e.target.value)
                  clearError('ZoneID');
                }}
              >
                <option value="">Select Zone*</option>
                {zoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {(formErrors.ZoneID || formData.errors?.ZoneID) && (
                <p className="Error_P" style={{ float: "left" }}><span> {formErrors.ZoneID || formData.errors?.ZoneID} </span></p>
              )}
            </div>
          </div>
        );
      
      case 'RTU':
        return (
          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Zone*</label>
              <select
                className="inputType ArrowSelectClass"
                value={formData.ZoneID || ""}
                onChange={(e) => {
                  handleZoneId('ZoneID', e.target.value)
                  clearError('ZoneID');
                }}
              >
                <option value="">Select Zone*</option>
                {zoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {(formErrors.ZoneID || formData.errors?.ZoneID) && (
                <p className="Error_P" style={{ float: "left" }}><span> {formErrors.ZoneID || formData.errors?.ZoneID} </span></p>
              )}
            </div>
          </div>
        );
      
      case 'FAS':
        return (
          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Zone*</label>
              <select
                className="inputType ArrowSelectClass"
                value={formData.ZoneID || ""}
                onChange={(e) => {
                  handleZoneId('ZoneID', e.target.value)
                  clearError('ZoneID');
                }}
              >
                <option value="">Select Zone*</option>
                {zoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {(formErrors.ZoneID || formData.errors?.ZoneID) && (
                <p className="Error_P" style={{ float: "left" }}><span> {formErrors.ZoneID || formData.errors?.ZoneID} </span></p>
              )}
            </div>
          </div>
        );
      
      case 'CCTV':
        return (
          <div>

            {/* <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Communication Port</label>
                <input
                  className="inputType"
                  placeholder="Enter Communication Port* e.g. 8080"
                  value={formData.Communicationport || ""}
                  onChange={(e) => handleZoneId('Communicationport', e.target.value)}
                />
                <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Live Stream Type</label>
                <select
                  className="inputType ArrowSelectClass"
                  value={formData.SubTypeLive || ""}
                  onChange={(e) => handleZoneId('SubTypeLive', e.target.value)}
                >
                  <option value="">Select Live Stream Type</option>
                  <option value="0">Main</option>
                  <option value="1">Sub</option>
                  <option value="2">Ter</option>
                </select>
                <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Playback Stream Type</label>
                <select
                  className="inputType ArrowSelectClass"
                  value={formData.SubTypePlayback || ""}
                  onChange={(e) => handleZoneId('SubTypePlayback', e.target.value)}
                >
                  <option value="">Select Playback Stream Type</option>
                  <option value="0">Main</option>
                  <option value="1">Sub</option>
                  <option value="2">Ter</option>
                </select>
                <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
              </div>
            </div> */}

           <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Zone*</label>
              <select
                className="inputType ArrowSelectClass"
                value={formData.ZoneID || ""}
                onChange={(e) => handleZoneId('ZoneID', e.target.value)}
              >
                <option value="">Select Zone*</option>
                {zoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {(formErrors.ZoneID || formData.errors?.ZoneID) && (
                <p className="Error_P" style={{ float: "left" }}><span> {formErrors.ZoneID || formData.errors?.ZoneID} </span></p>
              )}
            </div>
          </div>

          </div>
        );
      
      case 'IDS':
        return (
          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Zone*</label>
              <select
                className="inputType ArrowSelectClass"
                value={formData.ZoneID || ""}
                onChange={(e) => {
                  handleZoneId('ZoneID', e.target.value)
                  clearError('ZoneID');
                }}
              >
                <option value="">Select Zone*</option>
                {zoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {(formErrors.ZoneID || formData.errors?.ZoneID) && (
                <p className="Error_P" style={{ float: "left" }}><span> {formErrors.ZoneID || formData.errors?.ZoneID} </span></p>
              )}
            </div>
          </div>
        );
      
      default:
        return (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Please select a valid interface to load bulk edit form.</p>
          </div>
        );
    }
  };

  const showSiteForm = () => {
    setShowAddSite(true);
    // Reset row selection when opening form to avoid confusion
    setRowSelection({});
  }

  const showDeviceForm = async (data) => {
    setShowAddSite(true);
    setSelectedRow(data);
    // Extract Interface value from filterValues
    const interfaceValue = filterValues.Interface?.[0]?.value || null;

    // Fetch interface data when adding new device and editing as well
    if (interfaceValue) {
      try {
        
        const response = await getInterfaceById(interfaceValue);
        if (response && response.Status === 'success' && response.Data && response.Data.length > 0) {
          const interfaceInfo = response.Data[0];
          setInterfaceData(interfaceInfo);
          // Map interface type name to device type
          const deviceTypeMapping = {
            'ACS': 'ACS',
            'CCTV': 'CCTV', 
            'RTU': 'RTU',
            'Fire Panel': 'FAS',
            'Alarm Panel': 'IDS'
          };
          
          const mappedDeviceType = deviceTypeMapping[interfaceInfo.Interfacetypename] || '';
          if(mappedDeviceType === "IDS"){
            if(deviceData.length > 0){
              setSelectedRow(deviceData[0]);
            }
          }
          // For new devices, set the device type from interface mapping
          // For editing, preserve existing device type if available
          if (!data) {
            setSelectedDeviceType(mappedDeviceType);
          } else if (data.deviceType) {
            setSelectedDeviceType(data.deviceType);
          } else {
            setSelectedDeviceType(mappedDeviceType);
          }
          
        } else {
          console.warn('No interface data received or failed to fetch');
          setInterfaceData(null);
          if (!data) {
            setSelectedDeviceType('');
          }
        }
      } catch (error) {
        console.error('Error fetching interface data:', error);
        setInterfaceData(null);
        if (!data) {
          setSelectedDeviceType('');
        }
      }
    }

    // Reset row selection when opening form to avoid confusion
    setRowSelection({});
    // Reset form data when opening new form
    if (!data) {
      setFormData({});
      setFormErrors({});
    } else {
      // If editing, set device type based on existing data
      setFormData(data);
      setFormErrors({});
    }
  }

  const handleDeviceTypeChange = (deviceType) => {
    setSelectedDeviceType(deviceType);
    // Reset form data when device type changes
    setFormData({ deviceType });
    setFormErrors({});
  };

  const handleFormDataChange = (newFormData) => {
    setFormData(newFormData);
  };

  const handleCancelDeviceForm = () =>{
    setShowAddSite(false);
    setSelectedRow(null);
    setFormData({});
    setSelectedDeviceType('');
    setFormErrors({});
    setInterfaceData(null); // Clear interface data when form is closed

    //fetchFilters(); // Refresh filters when form is closed
  }

  const renderDeviceForm = () => {
    const siteId = filterValues.Site?.[0]?.value || null;
    const customerId = filterValues.Customer?.[0]?.value || null;
    const interfaceId = filterValues.Interface?.[0]?.value || null;

    const commonProps = {
      formData,
      onFormDataChange: handleFormDataChange,
      errors: formErrors,
      isEditMode: !!selectedRow,
      onCancel: handleCancelDeviceForm,
      interfaceData: interfaceData, // Pass interface data to forms,
      siteId: siteId,
      customerId: customerId,
      handleApplyFilters,
      selectedRow,
      filterValues
    };

    switch (selectedDeviceType) {
      case 'CCTV':
      case 'Camera':
        return <CCTVDeviceForm {...commonProps} />;
      case 'ACS':
      case 'ACS Controller':
      case 'ACS Reader':
        return <ACSDeviceForm {...commonProps} />;
      case 'RTU':
      case 'RTU Controller':
        return <RTUDeviceForm {...commonProps} />;
      case 'FAS':
      case 'Fire Panel':
        return <FASDeviceForm {...commonProps} />;
      case 'IDS':
      case 'IDS Panel':
        return <IDSDeviceForm {...commonProps} />;
      default:
        return null;
    }
  };

  
  const getSelectedDeviceIds = () => {
    // rowSelection now contains actual device IDs as keys, not row indices
    const selectedDeviceIds = Object.keys(rowSelection).filter(key => rowSelection[key]);
    return selectedDeviceIds;
  };

  const onBulkEditDevices = async () => {
    const selectedIds = getSelectedDeviceIds();
    if (selectedIds.length === 0) {
      alert('Please select at least one device to edit.');
      return;
    }
    
    setSelectedDeviceIds(selectedIds)
    
    // Get interface ID from filter values
    const interfaceValue = filterValues.Interface?.[0]?.value || null;
    
    if (!interfaceValue) {
      alert('Interface information is required for bulk edit.');
      return;
    }

    setBulkEditLoading(true);
    setShowBulkEditModal(true);
    
    try {
      const response = await getInterfaceById(interfaceValue);
      
      if (response && response.Status === 'success' && response.Data && response.Data.length > 0) {
        const interfaceInfo = response.Data[0];
        
        // Map interface type name to device type for bulk edit
        const deviceTypeMapping = {
          'ACS': 'ACS',
          'CCTV': 'CCTV', 
          'RTU': 'RTU',
          'Fire Panel': 'FAS',
          'Alarm Panel': 'IDS'
        };
        
        const mappedDeviceType = deviceTypeMapping[interfaceInfo.Interfacetypename] || '';
        setBulkEditDeviceType(mappedDeviceType);
        
        // Fetch zones for bulk edit
        await fetchZones();
        
      } else {
        console.warn('No interface data received for bulk edit');
        setBulkEditDeviceType('');
        alert('Failed to fetch interface information for bulk edit.');
      }
    } catch (error) {
      console.error('Error fetching interface data for bulk edit:', error);
      setBulkEditDeviceType('');
      alert('Error occurred while fetching interface information.');
    } finally {
      setBulkEditLoading(false);
    }
  };

  const clearError = (field) => {
    setFormErrors(prevErrors => ({
      ...prevErrors,
      [field]: ''
    }));
  };

  const onBulkEditSubmit = async () => {
    try {
      setBulkEditLoading(true);
      
      const selectedIds = getSelectedDeviceIds();
      if (selectedIds.length === 0) {
        alert('No devices selected for bulk edit.');
        return;
      }

      // Validate required fields based on device type
      let hasValidationErrors = false;
      let validationMessage = '';
      let tempErrors = {
        ZoneID: ''
      }
      if (['ACS', 'RTU', 'FAS', 'IDS'].includes(bulkEditDeviceType)) {
        if (!formData.ZoneID) {
          hasValidationErrors = true;
          validationMessage = 'Zone is required.';
          tempErrors.ZoneID = 'Zone is required.'
        }
      } else if (bulkEditDeviceType === 'CCTV') {
        // Add CCTV specific validation if needed
        // For now, CCTV fields are optional in bulk edit
        if(!formData.ZoneID) {
          hasValidationErrors = true;
          validationMessage = 'Zone is required.';
        }
      }

      if (hasValidationErrors) {
        ErrorToast(validationMessage);
        setFormErrors(tempErrors);
        return;
      }

      // Get user ID from localStorage
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userID = user.Id || '';

    
      // Prepare payload based on device type
      const payload = {
        UserID: userID,
        DeviceID: selectedIds.map(id => parseInt(id)) // Convert to numbers
      };

      // Add fields based on device type
      if (['ACS', 'RTU', 'FAS', 'IDS'].includes(bulkEditDeviceType)) {
        payload.SiteID = parseInt(formData.ZoneID);
      } else if (bulkEditDeviceType === 'CCTV') {
        // Add CCTV specific fields if they have values4
        // if (formData.Communicationport) {
        //   payload.Communicationport = formData.Communicationport;
        // }
        // if (formData.SubTypeLive) {
        //   payload.SubTypeLive = parseInt(formData.SubTypeLive);
        // }
        // if (formData.SubTypePlayback) {
        //   payload.SubTypePlayback = parseInt(formData.SubTypePlayback);
        // }
        payload.ZoneID = parseInt(formData.ZoneID);
      }


      // Call the API
      const response = await updateBulkDeviceDetails(payload);
      
      if (response && response.Status === 'success') {
        SuccessToast(response.Message || 'Devices updated successfully');
        setShowBulkEditModal(false);
        setRowSelection({}); // Clear selection
        handleApplyFilters(); // Refresh the data
      } else {
        alert(response?.Message || 'Failed to update devices. Please try again.');
      }
    } catch (error) {
      console.error('Error updating devices:', error);
      alert('An error occurred while updating devices. Please try again.');
    } finally {
      setBulkEditLoading(false);
    }
  };

  const onDeleteChange = (e, row) => {
    e.stopPropagation();
    Swal.fire({
      title: "Are you sure?",
      text: `You really want to delete "${row.DeviceName}" device!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteDevices(row.DeviceId, row?.DeviceType);
      }
    });
  }

  const onBulkDeleteDevice = (e) => {
    e.stopPropagation()
    const selectedIds = getSelectedDeviceIds();
    if (selectedIds.length === 0) {
      alert('Please select at least one device to delete.');
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete the selected devices?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#027aaa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete!"
    }).then((result) => {
      if (result.isConfirmed) {
        // Implement bulk delete logic here
        handleApplyFilters(); // Refresh data after deletion
      }
    })
  }

  const onDeleteDevice = (e, deviceId, name) => {
    e.stopPropagation();
        Swal.fire({
          title: "Are you sure?",
          text: `Deleting the Interface will delete all the entites associated with it. Do you really want to delete ${name} interface!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            deleteDevices(deviceId)
          }
        });
  }

  const deleteDevices = async (deviceId, deviceType) => {
      let userId = localStorage.getItem("UserID");
      await deleteDeviceService(userId, deviceId)
        .then((resp) => {
          if (resp.Status == "success") {
            SuccessToast(resp.Message);
            handleApplyFilters();
            fetchFilters();
            return;
          } else if (resp.Status === "failed") {
            if(resp.Message == "Cannot delete device, please delete existing devices first." && deviceType === "IDS Panel"){
              Swal.fire({ text: 'Cannot delete device, please delete existing zones first.' });
            }else{
              Swal.fire({ text: resp.Message });
            }
          } else {
            Swal.fire({ text: "Something went wrong, please try again later!" });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

  useEffect(() => {
    if (wrapperRef.current) {
      const labelEl = wrapperRef.current.querySelector(
        ".dropdown-heading .dropdown-heading-value"
      );
      if (labelEl) {
        const firstFilterKey = Object.keys(pageFilters)[0];
        const firstSelection = filterValues[firstFilterKey];
        const selectedLabel = firstSelection?.[0]?.label || "";
        const isTruncated = labelEl.scrollWidth > labelEl.clientWidth;
        labelEl.setAttribute("title", isTruncated ? selectedLabel : "");
      }
    }
  }, [filterValues]);

  // Generate filter summary for display
  const getFilterSummary = () => {
    const activeFilters = Object.entries(filterValues)
      .filter(([key, value]) => Array.isArray(value) && value.length > 0)
      .map(([key, value]) => {
        const config = pageFilters[key];
        const label = config ? config.label : key;
        const selectedLabel = value[0]?.label || value[0];
        return `${label}: ${selectedLabel}`;
      });
    
    return activeFilters.length > 0 ? activeFilters.join(' | ') : 'No filters applied';
  };

  return (
    <>
      <div className='p-3'>
        {showAddSite ? (
          <div className="SiteMainContainer SiteTableMainDiv p-2">
            <h5>{selectedRow ? 'Edit Device' : 'Add new device'}</h5>
            <div className='SiteFormAdditionForm DeviceAdditionFormsHeight'>
              <>
              {/* <div className="site-form">
                
                <div className="inputMainContainer w40dot75rem">
                  <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>System</label>
                    <select
                      className="inputType ArrowSelectClass"
                      value={selectedDeviceType}
                      onChange={(e) => handleDeviceTypeChange(e.target.value)}
                      disabled={!selectedRow} // Disabled when adding (based on interface), enabled when editing
                    >
                      <option value="">Select Device Type*</option>
                      <option value="CCTV">CCTV Camera</option>
                      <option value="ACS">Access Control System</option>
                      <option value="RTU">Remote Terminal Unit</option>
                      <option value="FAS">Fire Alarm System</option>
                      <option value="IDS">Intrusion Detection System</option>
                    </select>
                    {formErrors.deviceType && <p className="Error_P" style={{ float: "left" }}><span>{formErrors.deviceType}</span></p>}
                  </div>
                </div>
              </div> */}

                {/* Render appropriate device form based on selected type */}
                {selectedDeviceType && renderDeviceForm()}
              </>
            </div>
          </div>  
        ) : (
          <div className="SiteMainContainer SiteTableMainDiv">
            <div className="DashboardFilterMainDiv">
              <div className="RefreshText" style={{ display: "flex" }}>
                {Object.entries(pageFilters)
                  .sort(([, a], [, b]) => a.sequence - b.sequence)
                  .map(([filterKey, filterConfig]) => (
                    <div key={filterKey} className="inputTypeLabelContainer">
                      <label className="formFieldLabels">
                        {filterConfig.label}
                        {filterConfig.mandatory && <span style={{ color: 'red' }}>*</span>}
                      </label>
                      <div ref={wrapperRef}>
                        <MultiSelect
                          key={filterValues[filterKey]?.[0]?.value}
                          options={getFilterOptions(filterKey)}
                          value={filterValues[filterKey] || []}
                          onChange={(value) => handleFilterChange(filterKey, value.length > 1 ? [value[value.length - 1]] : value)}
                          labelledBy={`Select ${filterConfig.label}`}
                          hasSelectAll={false}
                          isCreatable={false}
                          disableSearch={false}
                          className="SiteConfigSingleSelectDropdownContainer"
                          overrideStrings={{
                              selectSomeItems:
                                  (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                      ? filterValues[filterKey][0].label
                                      : getPlaceholderText(filterKey, filterConfig),
                              allItemsAreSelected:
                                  (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                      ? filterValues[filterKey][0].label
                                      : getPlaceholderText(filterKey, filterConfig),
                          }}
                        />
                      </div>
                    </div>
                  ))}
                <div className="HMFilterDiv">
                  <Tooltip title={getFilterButtonTooltip()} placement="bottom">
                    <button 
                      className="IconsButtonDiv" 
                      name="filterBtn"
                      disabled={isMandatoryFiltersMissing() || loading}
                      style={{ 
                        opacity: (isMandatoryFiltersMissing() || loading) ? 0.5 : 1,
                        cursor: (isMandatoryFiltersMissing() || loading) ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleApplyFilters}
                    >
                      <img
                        src={FilterIcon}
                        className="camera-icon-height"
                        alt="Apply filter icon"
                      />
                    </button>
                  </Tooltip>
                  <Tooltip title="Clear Filter" placement="bottom">
                    <button 
                      className="IconsButtonDiv" 
                      name="clearFilterBtn"
                      disabled={loading}
                      style={{ 
                        opacity: loading ? 0.5 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleClearAllFilters}
                    >
                      <img
                        src={ClearFilter}
                        className="camera-icon-height"
                        alt="Clear filter icon"
                      />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="SiteMainHeightDiv">
              <div className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv" style={{ height: "calc(100vh - 290px)" }}>
                <div className="card-body p-0">
                  {loading ? (
                    <Box 
                      display="flex" 
                      justifyContent="center" 
                      alignItems="center" 
                      minHeight="400px"
                      flexDirection="column"
                    >
                      <CircularProgress size={60} thickness={4} />
                      <Box mt={2}>
                        <span style={{ fontSize: '16px', color: '#666' }}>Loading device data...</span>
                      </Box>
                    </Box>
                  ) : deviceData.length === 0 ? (
                    <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                      <AlertTemplateMessage
                        message={
                          !filtersApplied || isMandatoryFiltersMissing()
                            ? "Please select mandatory filters and click Apply Filter to load device data."
                            : "No devices found for the selected filters."
                        }
                      />
                    </div>
                  ) : (
                    <MaterialReactTable
                      columns={columns}
                      data={pagedData}
                      enableGlobalFilter={true}
                      enableColumnFilters={false}
                      enableStickyHeader
                      enableColumnResizing={true}
                      globalFilterFn="contains"
                      columnResizeMode="onEnd"
                      enableColumnOrdering={true}
                      enableRowSelection={true}
                      muiTableHeadCellProps={{
                        className: "myHeaderSelectAll",
                      }}
                      enableHiding={true}
                      displayColumnDefOptions={{
                        'mrt-row-select': {
                          visibleInShowHideMenu: false,
                          muiTableHeadCellProps: {
                            sx: {
                              position: "sticky",
                              left: 0,
                              backgroundColor: "#0b70d1",
                              borderTopLeftRadius: "20px",
                              color: "white",
                              fontWeight: "bold",
                              zIndex: 5,
                            },
                          },
                          muiTableBodyCellProps: {
                            sx: {
                              position: "sticky",
                              left: 0,
                              backgroundColor: "inherit",
                              zIndex: 4,
                            },
                          },
                        },
                      }}
                      initialState={{ showColumnFilters: false }}
                      manualPagination={true}
                      manualFiltering={true}
                      rowCount={filteredCount}
                      getRowId={(row) => row.DeviceId}
                      state={{
                        pagination: pagination,
                        rowSelection: rowSelection,
                        globalFilter: globalFilter,
                      }}
                      onRowSelectionChange={setRowSelection}
                      onPaginationChange={setPagination}
                      onGlobalFilterChange={handleGlobalFilterChange}
                      muiTableContainerProps={{
                        className: "MaterialTableJs myTableContainer",
                        sx: {
                          maxHeight: "100%",
                          overflowX: "auto",
                        },
                      }}
                      muiTableHeadProps={{
                        className: "myHeader",
                        sx: {
                          display: "table-header-group",
                        },
                      }}
                      renderTopToolbarCustomActions={({ table }) => (
                        <div className='d-flex justify-content-center align-items-center'>
                          <h4 style={{ margin: 0 }}>
                            List of devices {deviceData.length > 0 && `(${deviceData.length} records)`}
                          </h4>
                        </div>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className='mb-2 mt-2'>
              <Button 
                className='m-1 ConfigBelowButtons' 
                variant="contained" 
                onClick={() => showDeviceForm(null)}
                disabled={!filtersApplied}
                style={{ 
                  cursor: (!filtersApplied) ? 'not-allowed' : 'pointer',
                }}
              >
                Add Device
              </Button>
              <Button 
                className='m-1 ConfigBelowButtons' 
                variant="contained" 
                onClick={onBulkEditDevices}
                disabled={Object.keys(rowSelection).filter(key => rowSelection[key]).length === 0}
              >
                Bulk Edit {Object.keys(rowSelection).filter(key => rowSelection[key]).length > 0 && `(${Object.keys(rowSelection).filter(key => rowSelection[key]).length})`}
              </Button>
              {/* <Button 
                className='m-1' 
                variant="contained" 
                onClick={onBulkDeleteDevice}
                disabled={Object.keys(rowSelection).filter(key => rowSelection[key]).length === 0}
              >
                Bulk Delete {Object.keys(rowSelection).filter(key => rowSelection[key]).length > 0 && `(${Object.keys(rowSelection).filter(key => rowSelection[key]).length})`}
              </Button> */}
            </div>
          </div>
        )}
      </div>

      {/* Bulk Edit Modal */}
      <Modal
        show={showBulkEditModal}
        onHide={() => setShowBulkEditModal(false)}
        dialogClassName="widgetModelDiv"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <>
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              Device Bulk Edit
            </Modal.Title>
            <img
              src={RemoveIcon}
              alt="Remove"
              style={{ cursor: "pointer" }}
              onClick={() => { setShowBulkEditModal(false) }}
            />
          </Modal.Header>

          <Modal.Body>
            <div className='SiteFormAdditionForm border-top-0'>
              {bulkEditLoading ? (
                <Box 
                  display="flex" 
                  justifyContent="center" 
                  alignItems="center" 
                  minHeight="200px"
                  flexDirection="column"
                >
                  <CircularProgress size={60} thickness={4} />
                  <Box mt={2}>
                    <span style={{ fontSize: '16px', color: '#666' }}>Loading device information...</span>
                  </Box>
                </Box>
              ) : (
                <form style={{ width: "100%" }}>
                  <div className="site-form">    
                    {
                      bulkEditDeviceType === "CCTV"
                      ? <CCTVEditForm  zoneOptions={zoneOptions} setShowBulkEditModal={setShowBulkEditModal} selectedDeviceIds={selectedDeviceIds} handleApplyFilters={handleApplyFilters} setBulkEditLoading={setBulkEditLoading} />
                      :
                      renderBulkEditForm()
                    }
                  </div>
                </form>
              )}
            </div>
            {
              bulkEditDeviceType !== "CCTV"
              ? 
              <div style={{ textAlign: "center" }}>
              <button
                className="DataAccessEdit mt-3"
                style={{ width: "100px" }}
                disabled={bulkEditLoading}
                onClick={onBulkEditSubmit}
              >
                <span className="ViewUpdate">Submit</span>
              </button>
              <button 
                onClick={() => setShowBulkEditModal(false)}
                className="DataAccessEdit mt-3"
                style={{ width: "100px" }}
                disabled={bulkEditLoading}
              >
                <span className="ViewUpdate">Cancel</span>
              </button>
            </div>
              : null
            }

          </Modal.Body>
        </>
      </Modal>
    </>
  )
}

export default DeviceConfig